export default "__VITE_ASSET__9bc127cd__"